export const enum Routes {
  login = "/login",
  loginTwitter = "/login/twitter",
  loginTokenByToken = "/login/token/:token",
  loginForgot = "/login/forgot",
  loginForgotByEmail = "/login/forgot/:email",
  loginForgotByEmailByToken = "/login/forgot/:email/:token",
  logout = "/logout",
  signup = "/signup",
  signupEmail = "/signup/email",
  signupConfirm = "/signup/confirm",
  appointmentJoinByAppointmentId = "/appointment/join/:appointmentId",
  appointmentByAppointmentId = "/appointment/:appointmentId",
  conferenceByConferenceUuid = "/conference/:conferenceUuid",
  conferenceJoinByConferenceUuid = "/conference/join/:conferenceUuid",
  live = "/live",
  liveByUsername = "/:username/live",
  home = "/home",
  favorites = "/favorites",
  root = "/",
  rootByUsername = "/:username",
  user = "/user",
  messages = "/messages",
  groupJoinById = "/groups/join/:groupId",
  groupMessages = "/messages/group/:groupId",
  // Group Topics (Темы): a specific topic chat inside a group. topicId is a
  // numeric topic id, or the literal "general" for the group's General topic.
  groupMessageTopic = "/messages/group/:groupId/topic/:topicId",
  callByCallId = "/call/:callId",
  landing = "/landing",
  features = "/features",
  terms = "/terms",
  privacy = "/privacy",
}
